import {Box, Container, Grid, Paper, Typography, useTheme} from '@mui/material'
import step1 from '../assets/step1.mp4'
import step2 from '../assets/step2.mp4'
import step3 from '../assets/step3.mp4'
import {useTranslation} from 'react-i18next'

const StepsSesction = () => {
  const theme = useTheme()
  const [t] = useTranslation()

  return (
    <Box>
      <Container
        maxWidth="lg"
        sx={{
          paddingY: {xs: 5, md: 10},
          display: 'flex',
          flexDirection: 'column',
          gap: '100px'
        }}
      >
        {/* Step 1 */}
        <Paper
          elevation={2}
          sx={{
            padding: {xs: 2, md: 4},
            boxShadow: `10px 4px 50px 0px ${theme.palette.grey[400]}`,
            borderRadius: '30px'
          }}
        >
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6}>
              <Typography
                variant="h4"
                sx={{
                  maxWidth: {sm: 500, lg: 'auto'},
                  fontWeight: 700,
                  color: theme.palette.grey[900],
                  marginBottom: 6,
                  marginX: {xs: 'auto'},
                  textAlign: {xs: 'center', md: 'left'}
                }}
              >
                {t('fnd-home-steps-1-title')}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: theme.palette.grey[700],
                  textAlign: {xs: 'center', md: 'left'},
                  maxWidth: 400,
                  marginLeft: {xs: 'auto', md: 0},
                  marginRight: {xs: 'auto', md: 'auto'}
                }}
              >
                {t('fnd-home-steps-1-subtitle')}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                component="video"
                src={step1}
                autoPlay
                loop
                muted
                playsInline
                sx={{
                  width: '100%',
                  maxWidth: 500,
                  display: 'block',
                  marginX: 'auto',
                  borderRadius: '30px',
                  boxShadow: theme.shadows[2],
                  objectFit: 'cover'
                }}
              />
            </Grid>
          </Grid>
        </Paper>

        {/* Step 2 */}
        <Paper
          elevation={2}
          sx={{
            padding: {xs: 2, md: 4},
            boxShadow: `10px 4px 50px 0px ${theme.palette.grey[400]}`,
            borderRadius: '30px'
          }}
        >
          <Grid
            container
            spacing={4}
            direction="row-reverse"
            alignItems="center"
          >
            <Grid item xs={12} md={6}>
              <Typography
                variant="h4"
                sx={{
                  maxWidth: {sm: 500, lg: 'auto'},
                  fontWeight: 700,
                  color: theme.palette.grey[900],
                  marginBottom: 6,
                  marginX: {xs: 'auto'},
                  textAlign: {xs: 'center', md: 'right'}
                }}
              >
                {t('fnd-home-steps-2-title')}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: theme.palette.grey[700],
                  textAlign: {xs: 'center', md: 'right'},
                  maxWidth: 400,
                  marginLeft: {xs: 'auto', md: 'auto'},
                  marginRight: {xs: 'auto', md: 0}
                }}
              >
                {t('fnd-home-steps-2-subtitle')}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                component="video"
                src={step2}
                autoPlay
                loop
                muted
                playsInline
                sx={{
                  width: '100%',
                  maxWidth: 500,
                  display: 'block',
                  marginX: 'auto',
                  borderRadius: '30px',
                  boxShadow: theme.shadows[2],
                  objectFit: 'cover'
                }}
              />
            </Grid>
          </Grid>
        </Paper>

        {/* Step 3 */}
        <Paper
          elevation={2}
          sx={{
            padding: {xs: 2, md: 4},
            boxShadow: `10px 4px 50px 0px ${theme.palette.grey[400]}`,
            borderRadius: '30px'
          }}
        >
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6}>
              <Typography
                variant="h4"
                sx={{
                  maxWidth: {sm: 500, lg: 'auto'},
                  fontWeight: 700,
                  color: theme.palette.grey[900],
                  marginBottom: 6,
                  marginX: {xs: 'auto'},
                  textAlign: {xs: 'center', md: 'left'}
                }}
              >
                {t('fnd-home-steps-3-title')}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: theme.palette.grey[700],
                  textAlign: {xs: 'center', md: 'left'},
                  maxWidth: 400,
                  marginLeft: {xs: 'auto', md: 0},
                  marginRight: {xs: 'auto', md: 'auto'}
                }}
              >
                {t('fnd-home-steps-3-subtitle')}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                component="video"
                src={step3}
                autoPlay
                loop
                muted
                playsInline
                sx={{
                  width: '100%',
                  maxWidth: 500,
                  display: 'block',
                  marginX: 'auto',
                  borderRadius: '30px',
                  boxShadow: theme.shadows[2],
                  objectFit: 'cover'
                }}
              />
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </Box>
  )
}

export default StepsSesction
